import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { ApiService } from 'src/app/helpers/services/api.service';
import { HttpService } from 'src/app/helpers/services/http.service';
import { PublicService } from 'src/app/helpers/services/public.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private httpService: HttpService, private publicService: PublicService, private router: Router,
    private api: ApiService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/auth/refresh-token')) {
      return next.handle(req);
    }

    const encryptedData: any = localStorage.getItem(this.publicService.getActiveUserKey());
    const lang: any = localStorage.getItem(`${environment.prefix}-lang`);
    const data = this.publicService.decryptData(encryptedData);

    let authReq = req;

    if (data?.access_token) {
      authReq = req.clone({
        headers: req.headers
          .set('Authorization', `Bearer ${data.access_token}`)
          .set('Lang', lang)
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && data?.refresh_token) {
          let payload = {
            access_token: data.access_token,
            refresh_token: data.refresh_token
          };

          return this.httpService.action(this.api.auth.refreshToken, payload).pipe(
            switchMap((res: any) => {
              if (res?.data?.access_token && res?.data?.refresh_token) {
                data.access_token = res.data.access_token;
                data.refresh_token = res.data.refresh_token;
                localStorage.setItem(this.publicService.getActiveUserKey(), this.publicService.encryptData(data));

                const retryReq = req.clone({
                  headers: req.headers
                    .set('Authorization', `Bearer ${res.data.access_token}`)
                    .set('Lang', lang)
                });

                return next.handle(retryReq);
              }
              else {
                this.router.navigate(['/auth/login']);
                return throwError(() => error);
              }
            }),
            catchError(() => {
              this.router.navigate(['/auth/login']);
              setTimeout(() => {
                localStorage.removeItem(`${environment.prefix}-data`);
                localStorage.removeItem(`${environment.prefix}-temp-data`);
                localStorage.removeItem(`${environment.prefix}-search-history`);
              }, 500);
              return throwError(() => error);
            })
          );
        }

        return throwError(() => error);
      })
    );
  }
}
